import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading1, UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { trackOurNumbersShow } from '../../analytics';
import { NBSP } from '../../constants/symbols';

interface IOurNumbersProps {
  className?: string;
}

export const OurNumbers: React.VFC<IOurNumbersProps> = ({ className }) => {
  return (
    <ActionAfterViewObserver callback={trackOurNumbersShow} callbackDelay={1500} wrapper={false}>
      <div className={cn(styles['container'], className)} data-name="our_numbers">
        <div className={styles['title']}>
          <UIHeading1 as="h2">Почему нам доверяют</UIHeading1>
        </div>
        <div className={styles['group_list']}>
          <div className={styles['group']}>
            <div className={styles['number']}>
              <UIHeading1 as="h3" textAlign="center">
                300 000 +
              </UIHeading1>
            </div>
            <UIText2 textAlign="center">квартир в месяц оценивают на Циан</UIText2>
          </div>
          <div className={styles['group']}>
            <div className={cn(styles['number'], styles['decor_1'])}>
              <UIHeading1 as="h3" display="inline-block" textAlign="center">
                8 млн +
              </UIHeading1>
            </div>
            <UIText2 textAlign="center">объявлений в базе и проверка данных в{NBSP}Росреестре</UIText2>
          </div>
          <div className={styles['group']}>
            <UIHeading1 as="h3" textAlign="center">
              Точная модель анализа
            </UIHeading1>
            <UIText2 textAlign="center">ей доверяют банки и профессионалы</UIText2>
          </div>
        </div>
      </div>
    </ActionAfterViewObserver>
  );
};
